import { Injectable } from "@angular/core";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";

@Injectable()
export class BaseMarketplaceCreateListingService {

    constructor(private userService: NgUserService) {

    }

    getUserInfo() {
        return this.userService.getUserInfo();
    }
}
